// extracted by mini-css-extract-plugin
module.exports = {"detail":"ItemDetail_detail__2kUnI","supply":"ItemDetail_supply__YjFIJ"};